import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";

import * as ActionTypes from "Redux/actionTypes";

import {
  CustomContainer,
  useRouter,
  Row,
  Col,
} from "components/atoms/DependencyHelper";
import BackButton from "components/atoms/buttons/backButton/BackButton";
import LabelText from "components/atoms/label/LabelText";
import CartProductCard from "components/molecules/cartProductCard/CartProductCard";
import Image from "components/atoms/image/image";
import VasModal from "components/molecules/VasModal/VasModal";

import * as Analytics from "services/analyticsUtag";

import {
  formatNumbersWithComma,
  componentResize,
  getAmountOffValue,
  isArrayNotEmpty,
  numberToLocaleString,
} from "utils/helperServices";

import styles from "./CartListContainer.module.scss";

import labels from "../../../config/labels";
import config from "../../../config/index";

const CartListContainer = ({
  removeCartProduct,
  updateCartProduct,
  monthlyCartProducts,
  onceoffCartProducts,
  applicationType,
  alertFlag,
  handleAddRemoveToCartForVAS,
  shouldCloseModal,
  cartDetails,
  isVAS,
}) => {
  const isMobile = componentResize();
  const router = useRouter();

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const shoppingUrlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const [showVasModal, setShowVasModal] = useState(false);

  const { cartProductItems, prices, totalQuantity, cartLimits } =
    cartDetails || {};

  const subTotalIncludingTax = prices?.subtotal_including_tax?.value;

  const dispatch = useDispatch();
  const setLoadingState = (isLoading) => dispatch({
    type: ActionTypes.SET_IS_LOADING,
    payload: isLoading
  });

  const addVasToDealModal = () => {
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: add contract device insurance`,
    });
    setShowVasModal(true);
  };

  const closeVasModal = () => {
    setShowVasModal(false);
  };

  useEffect(() => {
    if (shouldCloseModal) {
      setShowVasModal(false);
    }
  }, [shouldCloseModal]);

  const navigateToShopLandingPage = () => {
    setLoadingState(true);

    if (cartProductItems.length) {
      const sales_order_discount = [];
      const sales_product_category = [];
      const sales_product_id = [];
      const sales_product_price = [];
      const sales_product_quantity = [];
      const sales_promo_name = [];
      const page_tool_event = [];
      const page_tool_name = [];

      cartProductItems.forEach((item) => {
        sales_order_discount.push(getAmountOffValue(item?.product));
        sales_product_id.push(item?.product?.name);
        sales_product_price.push(item?.prices?.row_total_including_tax?.value);
        sales_product_quantity.push(item?.quantity);
        sales_product_category.push(item?.product?.categories?.[0]?.name || "");
        if (item?.product?.promotion_tag_label) {
          sales_promo_name.push(item?.product?.promotion_tag_label);
        } else {
          sales_promo_name.push("");
        }
        if (item?.product?.stock_status.toLowerCase() === "out_of_stock") {
          page_tool_event.push("use");
          page_tool_name.push("shopping:cart:out of stock");
        } else {
          page_tool_event.push("");
          page_tool_name.push("");
        }
      });
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_subscription_type",
          "visitor_msisdn_hash",
        ]),
        link_type: "o",
        link_name: "shopping: cart: continue shopping",
        sales_order_discount,
        sales_product_category,
        sales_product_id,
        sales_product_price,
        sales_product_quantity,
        sales_promo_name,
      });
    } else {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_subscription_type",
          "visitor_msisdn_hash",
        ]),
        link_type: "o",
        link_name: "shopping: cart: continue shopping",
      });
    }
    router.push(`${shoppingUrlPrefix}/products`).then(() => {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  const dealProduct = monthlyCartProducts.filter(
    (cartProduct) =>
      cartProduct?.product?.is_deal_product === 1 &&
      cartProduct?.product?.__typename === labels.lbl_product_type_bundle
  );
  let dealSku = [];
  dealProduct.forEach((prod) => {
    if (prod?.product?.sku) {
      dealSku.push(prod?.product?.sku);
    }
  });

  let duplicateCounts = false,
    maxVas = 0;
  let dealVasProduct = [];
  dealSku.forEach((prodSku) => {
    cartProductItems.forEach((cartProduct) => {
      if (prodSku && cartProduct?.parent_product_sku == prodSku) {
        dealVasProduct.push(cartProduct);
      }
    });
  });

  let dealVasPrice = 0;
  dealVasProduct.forEach((item) => {
    if (
      dealSku &&
      item?.monthly_recurring &&
      item?.parent_product_sku == dealSku
    ) {
      dealVasPrice =
        parseFloat(dealVasPrice) + parseFloat(item?.monthly_recurring);
    }
    maxVas++;
  });

  dealVasProduct
    .map((v) => v?.product?.sku)
    .sort()
    .sort((a, b) => {
      if (a === b) duplicateCounts = true;
    });

  let dealPrice = 0;
  if (dealProduct && dealProduct.length > 1) {
    dealPrice = `R${formatNumbersWithComma(0)}`;
  } else {
    if (dealVasPrice) {
      dealVasPrice =
        parseFloat(dealProduct[0]?.product?.monthly_recurring) +
        parseFloat(dealVasPrice);
      dealPrice = `R${formatNumbersWithComma(dealVasPrice)} × ${
        dealProduct[0]?.product?.payment_terms_label
      }`;
    } else {
      dealPrice = `R${formatNumbersWithComma(
        dealProduct[0]?.product?.monthly_recurring
      )} × ${dealProduct[0]?.product?.payment_terms_label}`;
    }
  }

  let renderPopUp;

  if (duplicateCounts) {
    renderPopUp = labels.lbl_only_uniq_vas_allowed;
  } else if (maxVas > 4) {
    renderPopUp = labels.lbl_add_up_to_four;
  }

  if (totalQuantity > cartLimits?.cart_qty_limit) {
    renderPopUp = labels.lbl_cart_items_max_msg.replace(
      "<XY>",
      cartLimits?.cart_qty_limit
    );
  } else if (subTotalIncludingTax > cartLimits?.order_value_limit) {
    renderPopUp = labels.lbl_cart_order_max_msg.replace(
      "<RXX>",
      `R${numberToLocaleString(cartLimits?.order_value_limit)}`
    );
  }

  return (
    <CustomContainer className={styles["cart-list-container"]}>
      {alertFlag && renderPopUp && (
        <CustomContainer className={styles.limit}>
          <Image
            className={styles.img}
            img_path={`${imagePrefix}/assets/images/info-s-copy.svg`}
            img_width="1.3125rem"
            img_height="1.3125rem"
          />
          <LabelText className={styles["cart-limit-label"]}>
            {renderPopUp}
          </LabelText>
        </CustomContainer>
      )}

      {monthlyCartProducts && monthlyCartProducts.length > 0 && (
        <>
          <CustomContainer className={styles["cart-label-container"]}>
            <LabelText className={styles["cart-label"]}>
              {applicationType}
            </LabelText>
          </CustomContainer>

          {monthlyCartProducts.map((cartProduct, index) => (
            <CartProductCard
              key={`cart-item-${index}-${dealSku}`}
              cartProduct={cartProduct}
              dealSku={dealSku}
              removeCartProduct={(cartid, id, name, isDealProduct) =>
                removeCartProduct(cartid, id, name, isDealProduct)
              }
              updateCartProduct={(cartId, id, qty, name, isDealProduct) =>
                updateCartProduct(cartId, id, qty, name, isDealProduct)
              }
            />
          ))}

          <CustomContainer className={styles["add_contract"]}>
            <Row
              className={styles["add_contract_cart"]}
              id={"add_contract_cartProduct"}
            >
              <Col className={styles["add_contract_cart_btn"]}>
                {isVAS && (
                  <>
                    {!alertFlag && (
                      <div
                        onClick={addVasToDealModal}
                        className={styles["add_contract_cart_btn_display"]}
                      >
                        {labels.deal_details.lbl_new_contract_deal_vas}
                      </div>
                    )}

                    {alertFlag && (
                      <div className={styles["add_contract_cart_btn_disable"]}>
                        {labels.deal_details.lbl_new_contract_deal_vas}
                      </div>
                    )}
                  </>
                )}
              </Col>
            </Row>
          </CustomContainer>
          {!isMobile &&
            isArrayNotEmpty(monthlyCartProducts) &&
            !isArrayNotEmpty(onceoffCartProducts) && (
              <CustomContainer className={styles["cart-left-align"]}>
                <BackButton
                  labelText="Continue shopping"
                  labelStyle={styles["backbutton-label"]}
                  handleClick={navigateToShopLandingPage}
                  id={"cart-to-productlistBtn"}
                />
              </CustomContainer>
            )}
          <CustomContainer className={styles["deal-total-due"]}>
            <LabelText className={styles["cart-price-label"]}>
              {labels.deal_details.lbl_total_monthly_due}
            </LabelText>
            <LabelText className={styles["cart-price"]}>{dealPrice}</LabelText>
          </CustomContainer>
        </>
      )}

      {onceoffCartProducts && onceoffCartProducts.length > 0 && (
        <>
          <CustomContainer className={styles["cart-label-container"]}>
            <LabelText className={styles["cart-label"]}>
              {labels.lbl_once_off_purchase}
            </LabelText>
          </CustomContainer>
          {onceoffCartProducts.map((cartProduct) => (
            <CartProductCard
              cartProduct={cartProduct}
              key={cartProduct?.id}
              removeCartProduct={(cartid, id, name, isDealProduct) =>
                removeCartProduct(cartid, id, name, isDealProduct)
              }
              updateCartProduct={(cartId, id, qty) =>
                updateCartProduct(cartId, id, qty)
              }
            />
          ))}
        </>
      )}

      <CustomContainer className={styles["cart-bar"]}>
        {!isMobile &&
        ((isArrayNotEmpty(monthlyCartProducts) &&
          isArrayNotEmpty(onceoffCartProducts)) ||
          (!isArrayNotEmpty(monthlyCartProducts) &&
            isArrayNotEmpty(onceoffCartProducts))) ? (
          <CustomContainer className={styles["cart-left-align"]}>
            <BackButton
              labelText="Continue shopping"
              labelStyle={styles["backbutton-label"]}
              handleClick={navigateToShopLandingPage}
              id={"cart-to-productlistBtn"}
            />
          </CustomContainer>
        ) : null}

        {onceoffCartProducts && onceoffCartProducts.length > 0 && (
          <CustomContainer className={styles["cart-right-align"]}>
            <LabelText className={styles["cart-price-label"]}>
              {labels.lbl_total_once_off_due}
            </LabelText>
            <LabelText className={styles["cart-price"]}>
              {`R${formatNumbersWithComma(subTotalIncludingTax)}`}
            </LabelText>
          </CustomContainer>
        )}

        {showVasModal && (
          <VasModal
            showModal={showVasModal}
            handleCancel={closeVasModal}
            handleAddToCart={handleAddRemoveToCartForVAS}
            cartData={cartProductItems}
          ></VasModal>
        )}
      </CustomContainer>
    </CustomContainer>
  );
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartDetails,
  isVAS: state.common.features?.vas
});

CartListContainer.propTypes = {
  alertFlag: PropTypes.bool,
  applicationType: PropTypes.string,
  cartProducts: PropTypes.array,
  handleAddRemoveToCartForVAS: PropTypes.func,
  removeCartProduct: PropTypes.func,
  shouldCloseModal: PropTypes.bool,
  toTalPrice: PropTypes.number,
  updateCartProduct: PropTypes.func,
  monthlyCartProducts: PropTypes.arrayOf(PropTypes.object),
  onceoffCartProducts: PropTypes.arrayOf(PropTypes.object),
  
  // redux
  cartDetails: PropTypes.object,
  isVAS: PropTypes.bool,
};

export default connect(mapStateToProps)(CartListContainer);
